import { render, staticRenderFns } from "./BrandsHorizontalFilter.vue?vue&type=template&id=679c015e&scoped=true&"
import script from "./BrandsHorizontalFilter.vue?vue&type=script&lang=js&"
export * from "./BrandsHorizontalFilter.vue?vue&type=script&lang=js&"
import style0 from "./BrandsHorizontalFilter.vue?vue&type=style&index=0&id=679c015e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "679c015e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
